<div class="lightContent">
  <div class="headingPage">
    <h2 class="tablinks all_stories" 
    class="active" id="defaultOpen">Podcasts</h2>
  </div>
  <div id="allStories" style="display: block;">
    <div class="imageLibrary">
        <div class="listing"
          [pageId]="'podcast'"
          [showPagination]="false"
          (sendPodcastToParentfn)="sendPodcastToParent($event)">
        </div>
    </div>
  </div>
</div>

